import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
    DumpsterDto,
    DumpsterInputDto,
    DumpsterProvider,
    DumpsterService
} from '../../../../_services/configuration-services';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../../_shared/notifications.service';
import {CustomerConfigService} from '../../../../_shared/customer-config-service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormUtils} from '../../../../_shared/form-utils';
import {TenantCodes} from '../../../../app.constants';

@Component({
    selector: 'app-dumpster-management-modal',
    templateUrl: './dumpster-management-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DumpsterManagementModalComponent implements OnInit {

    @Input() serviceId: string;
    @Input() dumpster: DumpsterDto | null;

    FormUtils = FormUtils;

    dumpsterForm: UntypedFormGroup;

    tenantCodes = Object.entries(TenantCodes).map(([label, code]) => ({ label, code }));
    dumpsterProviders = Object.entries(DumpsterProvider).map(([label, value]) => ({ label, value }));

    constructor(public activeModal: NgbActiveModal,
                private readonly dumpsterService: DumpsterService,
                private readonly notificationService: NotificationsService,
                public readonly customerConfigService: CustomerConfigService) {

        this.dumpsterForm = new UntypedFormGroup({
                deviceId: new UntypedFormControl(null, [Validators.required, Validators.maxLength(50)]),
                nameFR: new UntypedFormControl(null, [Validators.required, Validators.maxLength(50)]),
                nameDE: new UntypedFormControl(null, Validators.maxLength(50)),
                nameIT: new UntypedFormControl(null, Validators.maxLength(50)),
                nameEN: new UntypedFormControl(null, Validators.maxLength(50)),
                descriptionFR: new UntypedFormControl(null, Validators.maxLength(100)),
                descriptionDE: new UntypedFormControl(null, Validators.maxLength(100)),
                descriptionIT: new UntypedFormControl(null, Validators.maxLength(100)),
                descriptionEN: new UntypedFormControl(null, Validators.maxLength(100)),
                tenantCode: new UntypedFormControl(null, Validators.required),
                dumpsterProvider: new UntypedFormControl(null, Validators.required)
            },
            {updateOn: 'change'}
        );
    }

    ngOnInit(): void {
        if (this.dumpster) {
            this.dumpsterProvider.disable();

            this.deviceId.setValue(this.dumpster.deviceId);
            this.nameFR.setValue(this.dumpster.nameFR);
            this.nameDE.setValue(this.dumpster.nameDE);
            this.nameIT.setValue(this.dumpster.nameIT);
            this.nameEN.setValue(this.dumpster.nameEN);
            this.descriptionFR.setValue(this.dumpster.descriptionFR);
            this.descriptionDE.setValue(this.dumpster.descriptionDE);
            this.descriptionIT.setValue(this.dumpster.descriptionIT);
            this.descriptionEN.setValue(this.dumpster.descriptionEN);
            this.tenantCode.setValue(this.dumpster.tenantCode);
            this.dumpsterProvider.setValue(this.dumpster.dumpsterProvider);
        }
    }

    public addOrUpdateDumpster(): void {
        if (this.dumpsterForm.invalid) {
            return;
        }

        const deviceToSave = new DumpsterInputDto({
            deviceId: this.deviceId.value,
            serviceId: this.serviceId,
            nameFR: this.nameFR.value,
            nameDE: this.nameDE.value,
            nameIT: this.nameIT.value,
            nameEN: this.nameEN.value,
            descriptionFR: this.descriptionFR.value,
            descriptionDE: this.descriptionDE.value,
            descriptionIT: this.descriptionIT.value,
            descriptionEN: this.descriptionEN.value,
            tenantCode: this.tenantCode.value,
            dumpsterProvider : this.dumpsterProvider.value,
        });

        if (!this.dumpster) {
            this.dumpsterService.createDumpster(deviceToSave).pipe().subscribe(_ => {
                this.notificationService.success({title: 'services.waste.notifications.addSuccess'});
                this.activeModal.close('success');
            });

        } else {
            this.dumpsterService.updateDumpster(this.dumpster.deviceId, deviceToSave).pipe().subscribe(_ => {
                this.notificationService.success({title: 'services.waste.notifications.updateSuccess'});
                this.activeModal.close('success');
            });
        }
    }

    get deviceId(): UntypedFormControl {
        return this.dumpsterForm.get('deviceId') as UntypedFormControl;
    }

    get nameFR(): UntypedFormControl {
        return this.dumpsterForm.get('nameFR') as UntypedFormControl;
    }

    get nameDE(): UntypedFormControl {
        return (this.dumpsterForm.get('nameDE') as UntypedFormControl);
    }

    get nameIT(): UntypedFormControl {
        return this.dumpsterForm.get('nameIT') as UntypedFormControl;
    }

    get nameEN(): UntypedFormControl {
        return this.dumpsterForm.get('nameEN') as UntypedFormControl;
    }

    get descriptionFR(): UntypedFormControl {
        return this.dumpsterForm.get('descriptionFR') as UntypedFormControl;
    }

    get descriptionDE(): UntypedFormControl {
        return this.dumpsterForm.get('descriptionDE') as UntypedFormControl;
    }

    get descriptionIT(): UntypedFormControl {
        return this.dumpsterForm.get('descriptionIT') as UntypedFormControl;
    }

    get descriptionEN(): UntypedFormControl {
        return this.dumpsterForm.get('descriptionEN') as UntypedFormControl;
    }

    get tenantCode(): UntypedFormControl {
        return this.dumpsterForm.get('tenantCode') as UntypedFormControl;
    }

    get dumpsterProvider(): UntypedFormControl {
        return this.dumpsterForm.get('dumpsterProvider') as UntypedFormControl;
    }
}
